import React, { useState, useContext } from 'react';
import { OnpContext } from './OnpLayout';
import ConsumptionCard from './ConsumptionCard';
import { translate } from '../../i18n/customI18nProvider';

const MAX_WIDTH = 800;

export default function OrderAndPay() {
  const { barInfo, order, consumptionChange, clearOrder, getConsumptionQuantity, getConsumptions } = useContext(OnpContext) || { barInfo: { consumptions: [] } };

  const navigationHeight = order.length > 0 ? 140 : 70;

  return (
    <div style={{ flex: 1, overflowY: 'auto', paddingBottom: "300px", scrollbarWidth: 'none', maxHeight: 'calc(100vh - 500px)' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <h3>{translate('custom.consumptions')}</h3>
        {barInfo.consumptions?.map((consumption) => (
          <ConsumptionCard
            key={consumption._id}
            consumption={consumption}
            quantity={getConsumptionQuantity(consumption._id)}
            onChange={(quantity) => consumptionChange(consumption._id, quantity)}
            allDeposits={barInfo.allDeposits || []}
          />
        ))}
        {
          barInfo.deposits?.length > 0 && (
            <>
              <h3>{translate('custom.deposits')}</h3>
              {
                barInfo.deposits.map((deposit) => (
                  <ConsumptionCard 
                    key={deposit._id} 
                    consumption={deposit} 
                    quantity={getConsumptionQuantity(deposit._id)}
                    onChange={(quantity) => consumptionChange(deposit._id, quantity)}
                    allDeposits={barInfo.allDeposits || []}
                  />
                ))
              }
            </>
          )
        }
      </div>        
    </div>
  );
}